import checkedSvg from "src/assets/icons/checked.svg"
import unCheckedSvg from "src/assets/icons/unchecked.svg"
import intermediateSvg from "src/assets/icons/intermediate-check.svg"
import MuiCheckbox, { CheckboxProps } from "@mui/material/Checkbox"
import SvgIcon from "../SvgIcon"
const CheckBox = (props: CheckboxProps) => {
  return (
    <MuiCheckbox
      sx={{ padding: 0.5 }}
      checkedIcon={<SvgIcon width={"0.85rem"} src={checkedSvg} />}
      icon={<SvgIcon width={"0.85rem"} src={unCheckedSvg} />}
      indeterminateIcon={<SvgIcon width={"0.85rem"} src={intermediateSvg} />}
      {...props}
    />
  )
}
export default CheckBox
